// Constants
import { ClientFlavor } from "@ms/uno-constants/lib/local/AppConstants";
import { SubRouteKeys, SubRouteType, ViewType } from "@ms/uno-constants/lib/local/RoutingConstants";
import { DefaultMyPlansPagePivotType, DefaultMyTasksViewPivotType } from "@ms/uno-constants/lib/local/ViewPivots";
import { getInitialSubRouteType } from "@ms/uno-routing/lib/local/utilities/RouteUtilities";
/**
 * Provides the initial route based on the app flavor and configuration
 */
export function getInitialRoute(clientFlavor, environment) {
    return {
        rootUrl: "", // TODO [ADO#8706197] - Should be the teams root url (but setting this currently breaks RouteStore - Need to investigate/fix)
        subRouteType: getInitialSubRouteType(clientFlavor, environment),
        subRoute: getInitialSubRoute(clientFlavor, environment),
        queryParameters: {},
    };
}
/**
 * Provide the initial subRoute based on the app flavor and configuration
 */
export function getInitialSubRoute(clientFlavor, environment) {
    if (clientFlavor === ClientFlavor.TaskFromMessage) {
        return [];
    }
    else {
        const subRouteType = getInitialSubRouteType(clientFlavor, environment);
        if (subRouteType === SubRouteType.MyPlans) {
            return [DefaultMyPlansPagePivotType];
        }
        return [DefaultMyTasksViewPivotType, SubRouteKeys.View, ViewType.Grid];
    }
}
